import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';

var _excluded = ["variant", "hierarchy", "floating", "state", "size", "label", "type", "width", "href", "isMultiLine"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultHierarchy = 'primary';
var defaultState = 'enabled';
var defaultType = 'button';
var defaultSize = 'l';
var defaultProps = {
  hierarchy: defaultHierarchy,
  state: defaultState,
  type: defaultType,
  size: defaultSize
};
var getSpacingToken = function getSpacingToken(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultSize : _ref$size,
    variant = _ref.variant,
    isMultiLine = _ref.isMultiLine;
  var spacingToken = {
    s: {
      label: {
        px: '12',
        py: isMultiLine ? '4' : undefined
      }
    },
    m: {
      label: {
        px: '16',
        py: '8'
      },
      icon: {
        px: '8',
        py: '8'
      }
    },
    l: {
      label: {
        px: '24',
        py: '12'
      },
      'label-caption': {
        px: '24',
        py: isMultiLine ? '4' : undefined
      },
      icon: {
        px: '12',
        py: '12'
      }
    }
  };
  return spacingToken[size][variant];
};
var typographyVariantToken = {
  s: 'body-s-strong',
  m: 'body-s-strong',
  l: 'body-default-strong'
};
var sizeToken = {
  s: '28px',
  m: '36px',
  l: '44px'
};
var backgroundColorToken = function backgroundColorToken(hierarchy, floating) {
  if (hierarchy === 'primary') return 'product.primary';
  if (floating || hierarchy === 'secondary') return 'base.surface';
  return undefined;
};
var textColorToken = function textColorToken(hierarchy, floating) {
  if (floating && hierarchy === 'tertiary') return 'base.default';
  var tokens = {
    primary: 'base.inverted',
    secondary: 'product.primary',
    tertiary: 'product.primary'
  };
  return tokens[hierarchy];
};
var disabledColorToken = 'deprecated.neutral.disabled-1';
var iconSizeToken = {
  s: '16',
  m: '20',
  l: '20'
};
var dotsLoaderVariantToken = function dotsLoaderVariantToken(hierarchy, floating) {
  if (floating && hierarchy === 'tertiary') return 'background';
  return hierarchy === 'primary' ? 'secondary' : 'primary';
};
var radialLoaderColorToken = function radialLoaderColorToken(hierarchy, floating) {
  if (floating && hierarchy === 'tertiary') return 'base.surface.floating.inverted';
  return hierarchy === 'primary' ? 'base.surface' : 'deprecated.primary.brand';
};
var isIconVariant = function isIconVariant(variant) {
  return variant === 'icon';
};
var isLabelCaptionVariant = function isLabelCaptionVariant(variant) {
  return variant === 'label-caption';
};
var isLoading = function isLoading(state) {
  return state === 'loading';
};
var getCaptionText = function getCaptionText(_ref2) {
  var caption = _ref2.caption,
    state = _ref2.state,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'l' : _ref2$size,
    variant = _ref2.variant;
  return !isLoading(state) && isLabelCaptionVariant(variant) && size === 'l' && caption;
};
var mapLeadingIcon = function mapLeadingIcon(_ref3) {
  var leadingIcon = _ref3.leadingIcon,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? defaultSize : _ref3$size,
    variant = _ref3.variant;
  return leadingIcon && {
    id: leadingIcon,
    size: iconSizeToken[size],
    me: !isIconVariant(variant) ? '8' : undefined
  };
};
var mapTrailingIcon = function mapTrailingIcon(_ref4) {
  var trailingIcon = _ref4.trailingIcon,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? defaultSize : _ref4$size,
    variant = _ref4.variant;
  if (isIconVariant(variant) || !trailingIcon) return undefined;
  return {
    id: trailingIcon,
    size: iconSizeToken[size],
    ms: '8'
  };
};
var mapLabelCaption = function mapLabelCaption(props) {
  var captionText = getCaptionText(props);
  if (!captionText) return undefined;
  var typographyProps = {
    variant: 'caption-default',
    textAlign: 'center',
    lineClamp: props.isMultiLine ? undefined : 1
  };
  return {
    captionText: captionText,
    typographyProps: typographyProps
  };
};
var mapLabelVariant = function mapLabelVariant(_ref5) {
  var leadingIcon = _ref5.leadingIcon,
    floating = _ref5.floating,
    _ref5$hierarchy = _ref5.hierarchy,
    hierarchy = _ref5$hierarchy === void 0 ? defaultHierarchy : _ref5$hierarchy,
    label = _ref5.label,
    loadingLabel = _ref5.loadingLabel,
    _ref5$state = _ref5.state,
    state = _ref5$state === void 0 ? defaultState : _ref5$state,
    _ref5$size = _ref5.size,
    size = _ref5$size === void 0 ? defaultSize : _ref5$size,
    variant = _ref5.variant,
    isMultiLine = _ref5.isMultiLine;
  if (isIconVariant(variant)) return undefined;
  return {
    boxProps: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row'
    },
    loaderProps: isLoading(state) ? {
      label: loadingLabel,
      variant: dotsLoaderVariantToken(hierarchy, floating)
    } : undefined,
    typographyProps: {
      tag: 'span',
      variant: typographyVariantToken[size],
      textAlign: leadingIcon ? 'start' : 'center',
      lineClamp: isMultiLine ? undefined : 1
    },
    typographyChildren: label
  };
};
var mapIconVariant = function mapIconVariant(_ref6) {
  var variant = _ref6.variant,
    _ref6$hierarchy = _ref6.hierarchy,
    hierarchy = _ref6$hierarchy === void 0 ? defaultHierarchy : _ref6$hierarchy,
    _ref6$state = _ref6.state,
    state = _ref6$state === void 0 ? defaultState : _ref6$state,
    _ref6$size = _ref6.size,
    size = _ref6$size === void 0 ? defaultSize : _ref6$size,
    loadingLabel = _ref6.loadingLabel,
    floating = _ref6.floating;
  if (!isIconVariant(variant)) return undefined;
  return {
    loaderProps: isLoading(state) ? {
      size: size === 's' ? 's' : 'm',
      color: radialLoaderColorToken(hierarchy, floating),
      label: loadingLabel
    } : undefined
  };
};
var mapContainerBox = function mapContainerBox(_ref7) {
  var variant = _ref7.variant,
    _ref7$hierarchy = _ref7.hierarchy,
    hierarchy = _ref7$hierarchy === void 0 ? defaultHierarchy : _ref7$hierarchy,
    floating = _ref7.floating,
    _ref7$state = _ref7.state,
    state = _ref7$state === void 0 ? defaultState : _ref7$state,
    _ref7$size = _ref7.size,
    size = _ref7$size === void 0 ? defaultSize : _ref7$size,
    label = _ref7.label,
    _ref7$type = _ref7.type,
    type = _ref7$type === void 0 ? defaultType : _ref7$type,
    width = _ref7.width,
    href = _ref7.href,
    isMultiLine = _ref7.isMultiLine,
    rest = _objectWithoutProperties(_ref7, _excluded);
  var disabled = state === 'disabled';
  var isDisabled = disabled || isLoading(state);
  var hasBackground = hierarchy !== 'tertiary';
  var hasBorder = hierarchy === 'secondary' && !floating;
  var spacing = getSpacingToken({
    size: size,
    variant: variant,
    isMultiLine: isMultiLine
  });
  var boxShadow = floating ? 'bottom-m' : undefined;
  var backgroundColor = disabled && hasBackground ? disabledColorToken : backgroundColorToken(hierarchy, floating);
  var textColor = disabled ? 'base.disabled' : textColorToken(hierarchy, floating);
  var borderRadius = isIconVariant(variant) ? 'max' : 'base';
  var borderColorToken = disabled ? disabledColorToken : 'base.default';
  var borderStyle = hasBorder ? 'solid' : undefined;
  var borderWidth = hasBorder ? '1' : undefined;
  var borderColor = hasBorder ? borderColorToken : undefined;
  var cursor = isDisabled ? 'default' : 'pointer';
  var interactive = !isDisabled ? textColor : undefined;
  var px = spacing === null || spacing === void 0 ? void 0 : spacing.px;
  var py = spacing === null || spacing === void 0 ? void 0 : spacing.py;
  var boxWidth;
  if (isIconVariant(variant)) boxWidth = sizeToken[size];else if (width === 'parent-fit') boxWidth = '100%';
  return {
    boxProps: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, rest), {}, {
      interactive: interactive,
      as: href ? 'a' : 'button',
      type: type,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: boxShadow,
      backgroundColor: backgroundColor,
      borderRadius: borderRadius,
      borderStyle: borderStyle,
      borderWidth: borderWidth,
      borderColor: borderColor,
      cursor: cursor,
      textColor: textColor,
      px: px,
      py: py,
      width: boxWidth
    }, isMultiLine ? {
      minHeight: sizeToken[size]
    } : {
      height: sizeToken[size]
    }), {}, {
      disabled: isDisabled
    }, href && {
      textDecoration: 'none'
    }), href && {
      href: href
    }),
    ariaLabel: isIconVariant(variant) ? label : undefined
  };
};

export { backgroundColorToken, defaultProps, mapContainerBox, mapIconVariant, mapLabelCaption, mapLabelVariant, mapLeadingIcon, mapTrailingIcon };
//# sourceMappingURL=Button.mappers.js.map
